
import { Component, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import math from '@/core/math'
import { Action, Getter } from 'vuex-class'
import {
  getCompanyAddressInfo,
  GetPreOrderInfoParamsDto,
  PreOrderListDto,
  ShopAddressListDto,
} from '@/api/buyCar'
import {
  getAdvanceOrder,
  PreOrderInfoListDto,
  submitStoreOrder,
  PickupConfigDto,
  PickupDetailDto
} from '@/api/industryMall'
import AppendixDialog from '@/views/orderManage/template/AppendixDialog.vue'
import { AppendixFileDto } from '@/api/commonConfig'
import AppendixName from '@/components/AppendixName/index.vue'
import { Debounce } from '@/core/decorator'
import { LoginReturnDataDto, callPhone, getUserLocationInfo, goToNavigation } from '@/utils/h5ToApp'
import { calculateDistance } from '@/utils/util'
import CountDown from '@/views/industryMall/buyCar/template/countDown.vue'
import store from '@/store'
import goodsListPopup from './template/goodsListPopup.vue'
const days = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

@Component({
  name: 'SubmitOrder',
  components: { AppendixDialog, AppendixName, CountDown,goodsListPopup }
})
export default class SubmitOrder extends Vue {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string
  @Getter providerId!: string
  @Getter preOrderParams!: GetPreOrderInfoParamsDto
  @Action setOrderDtlList!: (val: PreOrderListDto) => void
  @Getter info!: LoginReturnDataDto
  labelWidth = 80
  showCalendar = false
  showCalendarStore: any = {}
  defaultDate: any = null
  remark = ''
  orderData: PreOrderInfoListDto = {}
  submitData: any = {
    buyCompanyId: '',
    partnerCompanyId: '',
    cartFlag: ''
  }
  addressInfo: ShopAddressListDto = {
    isDefault: 0
  }
  currentOrderIndex!: number // 当前操作的订单下标
  isSubmit = false
  amountActive = false
  minDate = dayjs().toDate()
  maxDate = dayjs().toDate()
  pickupConfigList: Array<PickupConfigDto> = [] // 站点自提日期配置列表
  selectStore: any = {} // 日期选择store
  locationInfo = { longitude: 0, latitude: 1 } // 用户经纬度信息

  formatter (day: any) {
    const todayDateString = dayjs().format('YYYYMMDD')
    const dateString = dayjs(day.date).format('YYYYMMDD')
    if (dateString === todayDateString) {
      day.text = '今天'
    }
    return day
  }

  // 商品总价：总价 - 运费
  getGoodsPriceTotal (store) {
    const total = Number(math.mathSubtract(Number(store.goodsAllPrice), Number(store.payFreight || '0')))
    return total
  }

  // 合计：总价+服务费
  getStoreTotal (store) {
    let total = Number(math.mathAdd(Number(store.goodsAllPrice), Number(store.serviceMoney || '0')))
    if (store.distributionWay === 2) {
      total = Number(math.mathSubtract(total, Number(store.payFreight || '0')))
    }
    return total
  }

  // 所有店铺合计值
  get getAllPayMoney () {
    const price = this.orderData.storeList.reduce((prev, store: any) => {
      return prev + this.getStoreTotal(store)
    }, 0.00)
    return price
  }

  // 获取站点自提营业时间
  getWorkingTime(store: any) {
    return `${store.pickupConfig.pickupStartTime}-${store.pickupConfig.pickupEndTime}` // '09:00-18:00'
  }

  created() {
    this.getLocationInfo()
    this.submitData.buyCompanyId = this.companyId
    this.submitData.partnerCompanyId = this.info.partnerCompanyId
    this.submitData.cartFlag = this.$route.query.cartFlag === '1' // 是否是从购物车页面进入， ’1‘是， ’‘否
    this.getData()
    this.getAddressInfo()
  }

  // 切换配送方式
  async changeDeliveryWay (store: any, method: number) {
    // 切换为 1 判断店铺起送金额
    if (method === 1) {
      const goodsPrice = Number(math.mathSubtract(Number(store.goodsAllPrice), Number(store.payFreight || '0')))
      if (goodsPrice < Number(store.minDeliverGoodsMoney)) {
        return this.$toast.fail(`订单总价需达到 ${store.minDeliverGoodsMoney} 元才可送货上门`)
      }
    } else { // 切换为 2 判断店铺是否开启自提
      if (store.pickupConfig && store.pickupConfig.pickupStatus !== '1') {
        return this.$toast.fail('该店铺暂不支持站点自提')
      }
      store.pickupId = store.pickupConfig.pickupId
      // store.distance = calculateDistance(this.locationInfo.longitude, this.locationInfo.latitude, 113.950365, 22.54385)
    }
    store.distributionWay = method
    this.getSendTime(store)
  }

  getDistance (store: any) {
    if (this.locationInfo.longitude < 1) return '--'
    return calculateDistance(this.locationInfo.longitude, this.locationInfo.latitude, store.pickupConfig.pickupLongitude, store.pickupConfig.pickupLatitude)
  }

  /* 获取提交订单信息 */
  getData() {
    console.log('*****************', this.preOrderParams)
    getAdvanceOrder(this.preOrderParams).then((res) => {
      res.data.storeList.forEach(store => {
        const preStore = this.preOrderParams.storeList.find(i => i.storeId === store.storeId)
        console.log('preStore ***', preStore)
        // console.log('sendConfig ***', preStore.sendConfig)
        this.$set(store, 'distributionWay', Number(preStore.distributionWay)) // 配送方式（1送货上门、2站点自提）
        this.$set(store, 'deliveryDate', '2024-03-20') // 期望交货日期
        this.$set(store, 'address', '') // 收货地址
        this.$set(store, 'receiveAddressDtl', '') // 收货地址明细
        this.$set(store, 'receiveMobile', '') // 收货人手机
        this.$set(store, 'receiveMan', '') // 收货人
        this.$set(store, 'longitude', '') // 用户位置的经度
        this.$set(store, 'latitude', '') // 用户位置的纬度
        this.$set(store, 'pickupId', Number(preStore.distributionWay) === 2 ? preStore.pickupConfig.pickupId : '') // 自提点地址
        this.$set(store, 'sendConfig', preStore.sendConfig) // 送货上门时间设置
        this.$set(store, 'pickupConfig', preStore.pickupConfig) // 站点自提详细配置
        this.$set(store, 'pickupTimeConfig', preStore.pickupTimeConfig) // 站点自提时间配置
        this.getSendTime(store)
      })
      this.orderData = res.data
      const orderList = this.orderData.storeList || []
      this.submitData.storeList = orderList?.map((item) => {
        return {
          storeId: item.storeId,
          goodsCount: item.goodsCount,
          serviceMoney: item.serviceMoney,
          goodsAllPrice: item.goodsAllPrice,
          payFreight: item.payFreight,
          orderRemark: '',
          goodsPackageList: item.goodsPackageList.map((goods) => {
            return {
              goodsId: goods.goodsId,
              packageId: goods.packageId,
              orderQuantity: goods.orderQuantity
            }
          })
        }
      })
      this.submitData = JSON.parse(JSON.stringify(this.submitData))
    })
  }

  /* 获取地址信息 */
  getAddressInfo() {
    getCompanyAddressInfo({ companyId: this.companyId }).then((res) => {
      if (res.data.addressList && res.data.addressList.length > 0) {
        const list = res.data.addressList.filter((item) => item.isDefault)
        if (list && list.length > 0) {
          this.addressInfo = list[0]
          this.submitData.address = this.addressInfo.address
          this.submitData.receiveAddressDtl = this.addressInfo.addressDtl
          this.submitData.receiveMobile = this.addressInfo.receiveMobile
          this.submitData.receiveMan = this.addressInfo.receiveMan
          this.submitData.latitude = this.addressInfo.latitude
          this.submitData.longitude = this.addressInfo.longitude
        } else {
          this.addressInfo = {}
          this.submitData.address = ''
          this.submitData.receiveAddressDtl = ''
          this.submitData.receiveMobile = ''
          this.submitData.receiveMan = ''
          this.submitData.latitude = ''
          this.submitData.longitude = ''
        }
      }
    })
  }

  /* 显示选择日期弹窗 */
  showCalendarDialog(store: any) {
    this.showCalendarStore = store
    console.log('showCalendarDialog  ***', store)
    this.selectStore = store
    if (store.distributionWay === 1) {
      const b = this.isLaterThanLastTime(store.sendConfig.lastBuyTime)
      let m = Number(store.sendConfig.sendStartTime)
      let n = Number(store.sendConfig.sendEndTime)
      // 如果超过当天截止日期
      if (b) {
        m = m + 1
        n = n + 1
      }
      this.minDate = dayjs().add(m, 'day').toDate()
      this.maxDate = dayjs().add(n, 'day').toDate()
    } else if (store.distributionWay === 2) {
      const config = store.pickupTimeConfig
      if (config) {
        const b = this.isLaterThanLastTime(config.lastBuyTime)
        let m = Number(config.pickupStartTime)
        let n = Number(config.pickupEndTime)
        // 如果超过当天截止日期
        if (b) {
          m = m + 1
          n = n + 1
        }
        this.minDate = dayjs().add(m, 'day').toDate()
        this.maxDate = dayjs().add(n, 'day').toDate()
      }
    }
    this.showCalendar = true
  }

  // 当前时间是否比当天截止日期晚
  isLaterThanLastTime(lastBuyTime: string) {
    let d = new Date()
    const nowTimeString = dayjs().format('HH:mm:ss')
    let nowTime = d.setHours(Number(nowTimeString.split(':')[0]), Number(nowTimeString.split(':')[1]), Number(nowTimeString.split(':')[2]))
    let setTime = d.setHours(Number(lastBuyTime.split(':')[0]), Number(lastBuyTime.split(':')[1]), Number(lastBuyTime.split(':')[2]))
    return nowTime > setTime
  }

  // 获取默认送货上门日期 && 站点自提日期
  getSendTime(storeInfo: any) {
    const b = this.isLaterThanLastTime(storeInfo.distributionWay === 1 ? storeInfo.sendConfig.lastBuyTime : storeInfo.pickupTimeConfig.lastBuyTime)
    let m = Number(storeInfo.distributionWay === 1 ? storeInfo.sendConfig.sendStartTime : storeInfo.pickupTimeConfig.pickupStartTime)
    // 如果超过当天截止日期
    if (b) m = m + 1
    this.setDeliveryDayConfig(storeInfo, dayjs().add(m, 'day').toDate())
    this.defaultDate = dayjs().add(m, 'day').toDate()
  }

  /* 确认选择日期 */
  onConfirmData(date) {
    this.showCalendar = false
    this.setDeliveryDayConfig(this.selectStore, date)
  }

  // 设置送达日期
  setDeliveryDayConfig(store: any, selectDate: Date) {
    const selectDay = dayjs(selectDate).format('MM月DD日')
    const today = dayjs().format('MM月DD日')
    const tomorrow = dayjs().add(1, 'day').format('MM月DD日')
    store.sendDay = selectDay
    if (selectDay === today) {
      store.sendDay = '今天'
    } else if (selectDay === tomorrow) {
      store.sendDay = '明天'
    }
    store.weekNum = days[dayjs(selectDate).get('day')]
    store.deliveryDate = dayjs(selectDate).format('YYYY-MM-DD')
  }

  /* 套餐清单 */
  toMerchBill(data: PreOrderListDto) {
    this.setOrderDtlList(data)
    this.$router.push('/merchBill')
  }

  /* 显示上传附件弹窗 */
  showUploadFunc(index: number) {
    this.currentOrderIndex = index
    const data = this.submitData.orderList[this.currentOrderIndex]
    ;(this.$refs.appendixDialog as any).show({
      fileType: '6',
      orderFile: data.orderFileList
    })
  }

  /* 获取上传附件信息 */
  getUploadInfo(data: AppendixFileDto[]) {
    this.$set(
      this.submitData.orderList[this.currentOrderIndex],
      'orderFileList',
      data
    )
  }

  /* 提交订单 */
  @Debounce(500) // 防抖
  submitOrder() {
    if (!this.submitData.address && !(this.orderData.storeList.length === 1 && this.orderData.storeList[0].distributionWay === 2)) {
      return this.$toast('请先选择收货地址')
    }
    this.submitData.storeList.forEach(store => {
      const orderStore = this.orderData.storeList.find(orderStore => orderStore.storeId === store.storeId)
      store.distributionWay = orderStore.distributionWay // distributionWay	配送方式（1送货上门、2站点自提）
      // 如果是站点自提，要减去运费
      if (store.distributionWay === 2) store.goodsAllPrice = this.getGoodsPriceTotal(store)
      if (orderStore.distributionWay === 1) {
        store.JRaddress = this.addressInfo.jraddress
        store.address = this.addressInfo.address// 收货地址 distributionWay = 1 必传
        store.receiveAddressDtl = this.addressInfo.addressDtl // 收货地址明细 distributionWay = 1 必传
        store.receiveMobile = this.addressInfo.receiveMobile // 收货人手机 distributionWay = 1 必传
        store.receiveMan = this.addressInfo.receiveMan // 收货人 distributionWay = 1 必传
        store.longitude = this.addressInfo.longitude // 经度 distributionWay = 1 必传
        store.latitude = this.addressInfo.latitude // 纬度 distributionWay = 1 必传
        store.payFreight = orderStore.payFreight || 0
      } else {
        store.payFreight = 0
        store.pickupId = orderStore.pickupId // 自提点地址
      }
      store.deliveryDate = orderStore.deliveryDate // 期望交货日期 Yyyy-mm-dd
    })
    if (this.isSubmit) return false // 防止用户触发多次提交误点
    this.isSubmit = true
    submitStoreOrder(this.submitData)
      .then((res) => {
        if (res.code === '000000') {
          this.$router.replace({
            path: '/orderMallDetail',
            query: {
              orderId:res.data.orderList[0].orderId
            }
          })
          store.dispatch('getShopCarNum', this.info.partnerCompanyId)
        } else if (res.code === '000002') {
          const data = res.data
          if (
            data.rejectType === 'NonOrderable' ||
            data.rejectType === 'InvalidGoods'
          ) {
            this.$dialog
              .alert({
                message: `${data.goodsName}商品过期不存在`
              })
              .then(() => {
                //  刷新当前页面
                this.getData()
                this.getAddressInfo()
              })
          } else if (data.rejectType === 'InvalidPackage') {
            this.$dialog
              .alert({
                message: `${data.goodsName}商品所选规格过期不存在，请重新选择`
              })
              .then(() => {
                //  返回上一界面并刷新
                this.$router.back()
                window.sessionStorage.setItem('refresh', '1')
              })
          }
        }
      })
      .catch(() => {
        // this.amountActive = true
        this.getData()
      })
      .finally(() => (this.isSubmit = false))
  }

  // 调用原生enterSelectAddress方法去选择收获地址
  toSelectAddress() {
    const data = {
      customerId: this.companyId,
      isShowTemporary: false, // 是否展示临时地址信息 传false就是不展示，true就是展示
      title: '收货地址管理'
    }
    this.$bridge.callHandler('enterSelectAddress', { data }, (res) => {
      const address = !res ? {} : JSON.parse(res)
      console.log('res **********', res)
      console.log('address **********', address)
      this.addressInfo = address
      this.submitData.address = this.addressInfo.address
      this.submitData.receiveAddressDtl = this.addressInfo.addressDtl
      this.submitData.receiveMobile = this.addressInfo.receiveMobile
      this.submitData.receiveMan = this.addressInfo.receiveMan
      this.submitData.latitude = this.addressInfo.latitude
      this.submitData.longitude = this.addressInfo.longitude
      // address 收货地址 distributionWay === 1
      // receiveAddressDtl 收货地址明细 distributionWay === 1
      // receiveMobile 收货人手机 distributionWay === 1
      // receiveMan 收货人 distributionWay === 1
      // longitude 经度 distributionWay === 1
      // latitude 纬度 distributionWay === 1
      // pickupId 自提点地址 纬度 distributionWay === 2
      // deliveryDate 期望交货日期 yyyy-mm-dd
      // distributionWay 配送方式（1送货上门、2站点自提）
    })
  }

  makePhoneCall (phoneNumber: string) {
    callPhone({ tel: phoneNumber })
  }

  // 获取用户经纬度信息（从原生获取）
  getLocationInfo () {
    getUserLocationInfo().then((res: any) => {
      this.locationInfo.longitude = res.longitude
      this.locationInfo.latitude = res.latitude
      console.log('this.locationInfo ***', this.locationInfo)
    })
  }

  // 导航到自提点
  toNavigation (storeInfo: any) {
    console.log('storeInfo ***', storeInfo)
    // const params = {
    //   longitude: 113.950365,  // 经度，浮点型
    //   latitude: 22.54385, // 纬度，浮点型
    //   name: '深大地铁站'
    // }
    const params = {
      longitude: storeInfo.pickupConfig.pickupLongitude,  // 经度，浮点型
      latitude: storeInfo.pickupConfig.pickupLatitude, // 纬度，浮点型
      name: storeInfo.pickupConfig.pickupName
    }
    goToNavigation(params)
  }

  showGoodsList (store: any) {
    (this.$refs.goodsList as any).showPop(store)
  }
}
